import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import ModalComponent from  '../../../components/ModalComponent';
import { FaUsers } from "react-icons/fa";
import { Card, CardBody, Col, Row, Table } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import ListGroupUserComponent from '../../../components/Admin/group_users/ListGroupUserComponent';

class ListGroupUserPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            listGroupUser: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            groupUserId: 0,
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            name: '',
            alert: {
                error: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getGroupUser();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getGroupUser = () => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        // console.log(data)
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/user/getGroupUser',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listGroupUser: ref.data.content,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu nhóm khách hàng thất bại',
                })
            })
    }

    listGroupUser = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        }
        else {
            if ( this.state.listGroupUser.length ) {
                return (
                    this.state.listGroupUser.map( (groupUser, key) => {
                        return (
                            <ListGroupUserComponent
                                key={key}
                                groupUser={groupUser}
                                showModal = { (groupUser, action) => this.showModal(groupUser, action) }
                            />
                        )
                    })
                )
            }
            else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có đại lý trong dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

    showModal = (groupUser, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'delete' ) {
            titleModal = 'Xóa đại lý';
            modalBody = this.modalBody(groupUser, action);
            this.setState({
                groupUserId: groupUser.id
            })
        }
        else if (action === 'create') {
            titleModal = 'Tạo đại lý';
            modalBody = this.modalBody(groupUser, action);
            this.setState({
                name: '',
                groupUserId: 0
            })
        }
        else if (action === 'edit') {
            titleModal = 'Chỉnh sửa đại lý';
            modalBody = this.modalBody(groupUser, action);
            this.setState({
                name: groupUser.name,
                groupUserId: groupUser.id
            })
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
        })
    }

    modalBody = (groupUser, action) => {
        if ( action === 'create' ) {
            return (
                <>
                    <div className="form-group">
                        <label htmlFor="name">Tên đại lý</label>
                        <input type="text" name="name" className="form-control" id="name" placeholder="Tên đại lý" onChange={this.changeInput} />
                    </div>
                </>
            )
        }
        else if ( action === 'edit' ) {
            return (
                <>
                    <div className="form-group">
                        <label htmlFor="name">Tên đại lý</label>
                        <input type="text" name="name" className="form-control" id="name" placeholder="Tên đại lý" onChange={this.changeInput} defaultValue={ groupUser.name } />
                    </div>
                </>
            )
        }
        else if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa đại lý <b className="text-danger">{groupUser.name}</b> này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về đại lý này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
    }

    hiddenModal = () => {
        this.setState({
            userId: 0,
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        if ( this.validate() ) {
            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
            })
            let form = {
                userId: this.state.userId,
                action: this.state.action,
                name: this.state.name,
                groupUserId: this.state.groupUserId,
            };
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.put( process.env.REACT_APP_API_URL + '/api/admin/user/actionGroupUser', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        isSpinner: false,
                    });
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        if ( this.state.action === 'delete' ) {
                            if ( !ref.data.error ) {
                                this.state.listGroupUser.splice( this.state.userKey , 1);
                            }
                        }
                        else {
                            if ( !ref.data.error ) {
                                window.scrollTo(0, 0);
                                this.getGroupUser();
                            }
                        }
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    validate = () => {
        if ( this.state.action === 'create' ) {
            if ( this.state.name.length < 5 || this.state.name.length > 200 ) {
                this.setState({
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: (
                            <>
                                <Alert color="danger">
                                    <div className='text-center'>
                                        Số ký tự của Tên đại lý phải lớn hơn 5 ký tự hoặc nhỏ hơn 200 ký tự
                                    </div>
                                </Alert>
                                <div className="form-group">
                                    <label htmlFor="name">Tên đại lý</label>
                                    <input type="text" name="name" className="form-control" id="name" placeholder="Tên đại lý" onChange={this.changeInput} />
                                </div>
                            </>
                        )
                    },
                })
                return false;
            }
        }
        return true;
    }

    render() {
        return (
            <>
                <Breadcrumb title={"Quản lý nhóm khách hàng"} page={"Nhóm khách hàng"} icon={<FaUsers className="breadcrumb-icon" />} />
                <div className="row ml-3" style={{ marginTop: 20 }}>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-primary btn-sm mr-1" onClick={ () => this.showModal( null, 'create' ) }>Thêm đại lý</button>
                    </div>
                    <div className="col-md-12">
                        {
                            this.state.error ? (
                                <Alert color="danger">
                                    <div className='text-center'>
                                        { this.state.messageError }
                                    </div>
                                </Alert>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.checkNotification()
                        }
                    </div>
                </div>
                <Card>
                    <CardBody className="table-responsive">
                        <Row>
                            <Col>
                                <Card body>
                                    <Table className="table table-sm table-bordered table-hover rounded text-center">
                                        <thead className="primary">
                                            <tr>
                                                <th>Tên đại lý</th>
                                                <th>Số lượng khách hàng</th>
                                                <th>Số lượng nhóm sản phẩm</th>
                                                <th>Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { this.listGroupUser() }
                                        </tbody>
                                    </Table>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <ModalComponent
                    isModal={ this.state.isModal }
                    content={this.state.contentModal}
                    isBtnConfirm={ this.state.isBtnConfirm }
                    isSpinner={ this.state.isSpinner }
                    btnConfirmDisabled={ this.state.btnConfirmDisabled }
                    hiddenModal={ () => this.hiddenModal() }
                    confirmModal={ () => this.confirmModal() }
                    alert={ this.state.alert }
                />
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminGroupUser' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListGroupUserPage);